import styled from 'styled-components';
import { styleWithBreakPoints } from '~/src/components/LandingBlock/styled';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';

interface IBtnWrapProps {
    inline: boolean;
    align?: string;
}

export interface IBtnProps {
    backgroundColor?: string;
    backgroundHoverColor?: string;
    buttonTextColor?: string;
    propName?: string;
    isAutoWidth?: boolean;
}

export const ButtonWrap = styled.div<IBtnWrapProps>`
    display: ${p => p.inline ? 'inline-block' : 'flex' };
    justify-content: ${p => p.align ? p.align : 'left'};
    & a {
        text-decoration: none;
    }
`;

export const ButtonStyle = styled(BaseButton)<IBtnProps>`
    width: ${p => p.isAutoWidth ? 'auto' : '235px' };
    position: relative;
    z-index: 8;
    background-color: ${p => p.backgroundColor};
    border-color: ${p => p.backgroundColor};
    
    &:hover {
        background-color: ${p => p.backgroundHoverColor};
        border-color: ${p => p.backgroundHoverColor};
    }
    
    ${p => styleWithBreakPoints(p, `${p.propName || 'Button'}`)};
`;

export const ButtonText = styled.span<IBtnProps>`
    ${p => p.propName ? styleWithBreakPoints(p, `${p.propName + '.Text'}`) : styleWithBreakPoints(p, 'Button.Text')};
`;
